import React, { useEffect, useState, useMemo } from "react";
/*import '../Assets/Styles/addNewCarPopup.css';*/
//import car from '../Assets/Images/car.jpg'
//import "../Assets/Styles/carImages.css";
//import pencil from "../Assets/Images/pencil.svg"
//import upload from "../Assets/Images/upload.svg"
import sideImage from '../../asstes/images/add-car-left.svg';
import carIcon from '../../asstes/images/car-icon.svg';
import { Heading, Img, Button, Text, Switch } from "../../components";
import CarDetails from 'components/CarDetails';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ProposalDateRow from "../../components/ProposalDateRow";
import {API_DOMAIN_IMG, API_DOMAIN} from 'config';
/** ➋ קומפוננטת שדה-טופס קטנה (אפשר לשים בקובץ נפרד) */
import SendNewOfferColumncar10660x from "../../components/SendNewOfferColumncar10660x";
import CarCardTemplate from 'components/CarCardTemplate';
import UnderlineInput from "components/UnderlineInput";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { he } from "date-fns/locale";

import ContactDetails from "components/ContactDetails";
registerLocale("he", he);
export default function SendNewOfferPopup({ isRejectedOrApproved, onClose, car, currentUser, offer, onUpdateOffer })
{
  const [updatedOffer, setUpdatedOffer] = useState(null);

  const effectiveOfferStatus = Number(updatedOffer?.offer_status ?? offer?.offer_status ?? 0);
  const isApproved = effectiveOfferStatus === 2;

  const contactData = useMemo(() => {
    const base = {
      ...(car || {}),
      ...(offer || {}),
      ...(updatedOffer || {}),
    };

    return {
      ...base,
      supplier_name:
        updatedOffer?.supplier_name ?? offer?.supplier_name ?? car?.supplier_name,
      contact_name:
        updatedOffer?.contact_name ?? offer?.contact_name ?? car?.contact_name,
      contact_phone:
        updatedOffer?.contact_phone ?? offer?.contact_phone ?? car?.contact_phone,
      contact_location:
        updatedOffer?.contact_location ?? offer?.contact_location ?? car?.contact_location,
    };
  }, [car, offer, updatedOffer]);

const MAX_PRICE_DIGITS = 7; // תשני לפי מה שאת רוצה
const handlePriceChange = (e) => {
  // משאיר רק ספרות
  let v = String(e.target.value ?? "").replace(/\D/g, "");

  // חותך לאורך מקסימלי
  if (v.length > MAX_PRICE_DIGITS) v = v.slice(0, MAX_PRICE_DIGITS);

  setOfferForm((prev) => ({ ...prev, price: v }));
  if (errors.price) setErrors((p) => ({ ...p, price: "" })); // אופציונלי
};

    const CustomInput = React.forwardRef(({ value, onClick, label }, ref) => (
        <div className="">
          <input
            ref={ref}
            readOnly
            onClick={onClick}
            value={value ?? ""}
            placeholder="__/__/__"
            /* ——— עיצוב ——— */
            className="
              w-40
              bg-transparent
              text-right
              cursor-pointer
      
              /* לא רוצים שום קו־תחתון או גבול: */
              border-0
              border-b-0        /* במקרה שיש tailwind base שמוסיף */
              ring-0            /* מבטל ring של tailwind */
              focus:ring-0
              focus:outline-none
      
              placeholder:text-gray-400
            "
          />
          <span className="text-[16px] text-black-900_03 lg:text-[13px]">
            {label}
          </span>
        </div>
      ));
    const [step, setStep] = useState(1);
    const offerId = offer?.id || offer?.offer_id
    const [offerForm, setOfferForm] = useState({
      price: offer?.offered_price ?? "",
      offerDate: offer?.creation_date ? new Date(offer.creation_date) : new Date(),
      pickupDate: offer?.collection_date ? new Date(offer.collection_date) : "",
      lastPaymentDate: offer?.last_payment_date ? new Date(offer.last_payment_date) : "",
      reserve: !!offer?.is_reserved,
    });
    

    const isEdit = !!offer?.id || offer?.offer_status == 1;
    const isEditable = offer?.offer_status !== 2 && offer?.offer_status !== 3;
const [errors, setErrors] = useState({ price: "" });
const validatePrice = () => {
  const min = Number(car?.asking_price || 0);
  const val = Number(offerForm.price);

  if (!offerForm.price) {
    setErrors({ price: "מחיר הוא שדה חובה" });
    return false;
  }
  if (isNaN(val) || val < min) {
    setErrors({ price: `המחיר המינימלי הוא ₪${min.toLocaleString()}` });
    return false;
  }
  setErrors({ price: "" });
  return true;
};

      /** שינוי ערך */
      const handleChange = (e) => {
        const { name, value } = e.target;
        setOfferForm((prev) => ({ ...prev, [name]: value }));
      };


      const fmt = (d) =>
        d ? new Date(d).toISOString().slice(0, 19).replace("T", " ") : null;
    
      /** שליחת הטופס */
  /** שליחת הטופס */
/* ===== submitOffer – גרסה מתוקנת ===== */
const submitOffer = async () => {
  if (!validatePrice()) return;

  const carId   = Number(car?.car_id ?? car?.id);
  const offerId = Number(offer?.offer_id ?? offer?.id);

  const payload = {
    car_id: carId,
    user_id: currentUser?.id,
    offered_price: Number(offerForm.price),
    collection_date: fmt(offerForm.pickupDate),
    last_payment_date: fmt(offerForm.lastPaymentDate),
    is_reserved: offerForm.reserve ? 1 : 0,
    creation_date: offerForm.offerDate.toISOString().slice(0,19).replace("T"," "),
  };

  try {
    // 1) יצירה / עדכון
    if (offerId) {
      await axios.post(`${API_DOMAIN}/offer/updateOffer/${offerId}`, payload);
    } else {
      await axios.post(`${API_DOMAIN}/offer/addOffer`, payload);
    }

    // 2) משיכה מחדש – יתכן שמחזיר מערך / אובייקט
    const resp = await axios.get(`${API_DOMAIN}/offer/getUserOffer`, {
      params: { car_id: carId, user_id: currentUser.id },
    });
    const raw = resp?.data;
    const fresh =
      Array.isArray(raw) ? raw[0] :
      raw?.offer        ? raw.offer :
      raw;

    // 3) נרמול לאובייקט אחיד לעדכון הרשימה
    const upd = {
      ...(fresh || {}),
      offer_id: Number(fresh?.offer_id ?? fresh?.id ?? offerId),
      car_id:   carId,
      offered_price: Number(fresh?.offered_price ?? offerForm.price),
      collection_date: fresh?.collection_date ?? fmt(offerForm.pickupDate),
      last_payment_date: fresh?.last_payment_date ?? fmt(offerForm.lastPaymentDate),
      is_reserved: Number(fresh?.is_reserved ?? (offerForm.reserve ? 1 : 0)),
      // אם הסטטוס לא חזר – השאירי את הקיים, או 1 להצעה חדשה
      offer_status: Number(fresh?.offer_status ?? offer?.offer_status ?? 1),
    };

    setUpdatedOffer(upd);       // כדי שהכרטיס המסכם יצבע נכון
    onUpdateOffer?.(upd);       // ← עדכון האבא מידית
    setStep(2);                 // מסך "הצלחה"
    // אם תרצי לסגור אוטומטית אחרי הצלחה:
    // setTimeout(() => onClose?.(), 900);

  } catch (err) {
    console.error(err);
    alert("אירעה שגיאה בשמירת ההצעה");
  }
};


  
      
    return(

  <div className="popup-wrapper snop-root">
    <div className="popup-offer-container snop-container">
      <button className='x-close' onClick={onClose}>✕</button>

      {step == 1 &&
        <div>
          <h2 className="add-car-title snop-title" style={{ color: "black", marginBottom: "1.5rem" }}>
  {(offer?.offer_status !== 2 && offer?.offer_status !== 3) && (
    <>
      {isEdit ? "עדכן את ההצעה שלך" : "הגש הצעה חדשה"}
    </>
  )}
</h2>

       


          <div className="snop-layout flex items-start self-stretch sm:flex-col">
            <div className="new-offer-form snop-form mt-3.5 flex flex-1 flex-col items-start sm:self-stretch">
                <div className="flex  flex-col gap-3.5 ">
{/* === מחיר + הודעת שגיאה === */}
<div className="flex flex-col items-end gap-0.5">
  {/* שורה 1 – סימן ₪ + אינפוט */}
  <div className="flex items-end justify-end gap-[7px]">
    <Heading as="h3" className="!font-heebo text-[18px] font-bold">₪</Heading>

<input
  type="number"
  name="price"
  value={offerForm.price}
  onChange={handlePriceChange}
  inputMode="numeric"
  className={`
    w-32 border-0 border-b
    ${errors.price ? "border-red-500" : "border-blue_gray-400"}
    bg-transparent text-right
    focus:border-black focus:outline-none
  `}
  disabled={!isEditable}
/>

  </div>

  {/* שורה 2 – הודעת ולידציה (אם קיימת) */}
  {errors.price && (
    <Text className="text-red-600 text-sm">
      {errors.price}
    </Text>
  )}
</div>



              
  {/* תאריך הצעה + תאריך איסוף */}
  <div className="flex flex-col gap-3.5 md:flex-row items-end justify-end">
  <DatePicker
            style={{zIndex: '9999'}}
            popperClassName="my-datepicker-popper"

            locale="he"
            selected={offerForm.offerDate}
            dateFormat="dd/MM/yyyy"
            calendarStartDay={0}
            disabled               /* הופך את הקלט ללא‑קליק */
            customInput={<CustomInput label=":תאריך ההצעה" />}
                        popperContainer={({ children }) => <div style={{ zIndex: 99999 }}>{children}</div>}
  popperPlacement="bottom-start"

          />

          {/* תאריך איסוף */}
          <DatePicker
            locale="he"
            style={{zIndex: '99'}}
            withPortal
            popperClassName="my-datepicker-popper"
            selected={offerForm.pickupDate}
            onChange={(d) =>
              setOfferForm((p) => ({ ...p, pickupDate: d }))
            }
            dateFormat="dd/MM/yyyy"
            calendarStartDay={0}
            customInput={<CustomInput label=":תאריך איסוף" />}
                        popperContainer={({ children }) => <div style={{ zIndex: 99999 }}>{children}</div>}
            popperPlacement="bottom-start"
            disabled={!isEditable}   // ← הנעילה כאן
            minDate={new Date()}   // 👈 כאן החסם לתאריך עבר

          />

          {/* תאריך סיום תשלום */}
          <DatePicker
            locale="he"
            withPortal
            selected={offerForm.lastPaymentDate}
              popperClassName="my-datepicker-popper"

            onChange={(d) =>
              setOfferForm((p) => ({ ...p, lastPaymentDate: d }))
            }
            dateFormat="dd/MM/yyyy"
            calendarStartDay={0}
            customInput={<CustomInput label=":תאריך סיום תשלום" />}
              popperContainer={({ children }) => <div style={{ zIndex: 1000 }}>{children}</div>}
  popperPlacement="bottom-start"
  disabled={!isEditable}   // ← הנעילה כאן
  minDate={new Date()}   // 👈 כאן החסם לתאריך עבר

          />

  </div>
               
                  <div className="flex items-center justify-end">
<Switch
  checked={!offerForm.reserve}
  onCheckedChange={(val) => {
    if (!isEditable) return;  // ← חוסם פעולה כשהשדה נעול
    setOfferForm((prev) => ({ ...prev, reserve: !val }));
  }}
/>






<div className="flex self-end" style={{marginLeft:'2rem'}}>
                      <Text size="textxl" as="p" className="text-[16px] font-normal !text-black-900_03 lg:text-[13px]">
                        שיריון הרכב
                      </Text>
                    </div>
                  </div>    
                  
                  
                         {isApproved && (
            <div className="w-full flex justify-center relative mt-4">
              <ContactDetails
                data={contactData}
                buttonClassName="contacts-button"
                tooltipWrapperClassName="absolute left-1/2 -translate-x-1/2 top-full mt-2 z-[99999]"
              />
            </div>
          )}
                  
                  
                  {offer?.offer_status != 2 && offer?.offer_status != 3 &&

                  <div style={{display:'flex', justifyContent:'end', marginTop:'1rem'}}>
                    <button
                          size="lg"
                          shape="round"
                          leftIcon={
                            <div className="flex h-[10px] w-[6px] items-center justify-center">
                                       <span className="text-lg leading-none">‹</span>
    
                           
                            </div>
                          }
                          className="z-10 min-w-[128px] gap-2 rounded-[16px] px-3 font-semibold text-white snop-submitBtn "
                          style={{background: '#619D1C', color: 'white', padding: '5px', width: '40%'}}
                          onClick={submitOffer}
                          >
    {isEdit ? "עדכן הצעת מחיר" : "שלח הצעת מחיר"}
    </button>
                        </div>
}
                </div>
          
              </div>

                    <div className="flex  mt-3 justify-center hide-mobile" style={{ width: '25rem', position: 'relative', right: '74px' } }>
              <div  className =""
  style={{display: "flex", justifyContent: "center" }}>
                        <CarCardTemplate
                         key={car?.id} 
                         offer_status={offer?.offer_status ??0}
                        isRejectedOrApproved={isRejectedOrApproved}   // ← הוסף
                         {...car}   
                         className="w-[10%] self-center sm:w-full"
        offered_price={offerForm.price}
        />
        </div>
                    
           </div>

            </div>
          </div>}

          {step == 2 && (
  <div className="flex flex-col items-center justify-center h-full ">
    <h2 className="add-car-title">!!!מזל טוב</h2>
    <h2 style={{ color: 'black', marginBottom:'1rem' }} className="add-car-title">
    {isEdit ? "ההצעה שלך עודכנה בהצלחה" : "ההצעה שלך נשלחה בהצלחה"}

      
    </h2>
    <div className="flex justify-center w-full" >
    <CarCardTemplate
        key={car?.id}
        {...car}
        offer_status={updatedOffer?.offer_status ?? 1}
        offered_price={offerForm.price}
        className="w-full max-w-[300px] sm:w-[70%] self-center"
      />
    </div>
  </div>
)}

{/* פרטי התקשרות – רק אחרי אישור ההצעה */}
   

        </div>
    </div>
  
   

    );
}